import styled, { css } from 'styled-components';
import { Caption } from '../../text/TextComponent';
import { Icon } from '../../Icon/Icon';
import { svgIcons } from 'components/design/svgs';
import PropTypes from 'prop-types';

export const DropDownButton = ({ icon, title, children, isDisabled }) => {
	return (
		<>
			<StyledDropdownContainer isDisabled={isDisabled}>
				<DropdownButton>
					<StyledIcon>
						<Icon icon={icon}></Icon>
					</StyledIcon>
					<StyledSpan>{title}</StyledSpan> &nbsp;
					<StyledIcon>
						<Icon icon={svgIcons.faAngleDown}></Icon>
					</StyledIcon>
				</DropdownButton>
				<StyledDropdownContent>{children}</StyledDropdownContent>
			</StyledDropdownContainer>
		</>
	);
};

DropDownButton.propTypes = {
	isDisabled: PropTypes.bool,
	icon: PropTypes.any,
	title: PropTypes.string,
	children: PropTypes.node,
};

export const DropdownButton = styled.div(
	({ theme: { color } }) => css`
		border: none ${color.infoSeparator};
		cursor: pointer;
		position: relative;
		text-align: center;
		text-decoration: none;
		text-transform: initial;
		transition: box-shadow 0.2s ease-in 0s;
		background: linear-gradient(to top, ${color.dropdownButtonBg}, ${color.dropdownButtonBg});
		border-radius: 4px;
		color: ${color.dropdownItemBorder};
		margin: 0;
		padding: 10px 20px;
		display: flex;
		justify-content: center;
		align-items: center;
	`
);

export const StyledDropdownContent = styled.div(
	({ theme: { color, breakpoints, spacing } }) => css`
		display: none;
		position: absolute;
		background-color: ${color.formDisabledBg};
		box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
		z-index: 1;

		${breakpoints.tabletDown} {
			font-size: 13px !important;
		}

		a {
			color: black;
			padding: 12px ${spacing.lg};
			text-decoration: none;
			display: block;
			border-bottom: 1px solid ${color.infoSeparator};

			&:hover {
				background-color: ${color.buttonDisabled};
			}
		}
	`
);

const StyledDropdownContainer = styled.div(
	({ isDisabled, theme: { color } }) => css`
      opacity: ${isDisabled ? '0.4' : '1'} ;
      cursor: ${isDisabled ? 'not-allowed' : 'pointer'} ;
      pointer-events: ${isDisabled ? 'none' : ''};
      margin: 0 0 0 10px;
      display: inline-block;

      &:hover ${StyledDropdownContent} {
        display: block;
      }

      &:hover ${DropdownButton} {
        background: ${color.infoSeparator};
        color: ${color.infoSeparator};
      }
    }
    `
);

export const StyledSpan = styled(Caption)(
	({ theme: { fontSize, breakpoints } }) => css`
		font-size: ${fontSize._14};
		padding: 0 5px;

		${breakpoints.tabletDown} {
			display: none;
		}
	`
);

export const StyledIcon = styled(Caption)(
	({ theme: { breakpoints } }) => css`
		cursor: pointer;
		display: flex;
		justify-content: center;
		align-items: center;

		svg {
			height: 14px;
			display: inline-block;

			${breakpoints.tabletDown} {
				height: 13px;
			}

			path {
				fill: black;
			}
		}
	`
);
